import path from 'path';
import { Prompt } from 'react-router-dom';
import React, { Component } from 'react';
import { v4 as uuidV4 } from 'uuid';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'underscore';
import { viewPermissionSelector } from '../../common/classes/permissions';
import entityComposition from '../../common/classes/entityComposition';
import { hasAdminSubSectionPermission } from '../../../utils/paths';
import SectionPanel from '../../common/containers/sectionPanel';
import OrgConditionCosts from './organizationConditionCosts';
import routeHelper from '../../common/classes/routeHelper';
import OrgContainer from './organizationContainer';
import OrgGeneral from './organizationGeneral';
class Organization extends Component {
  constructor(props) {
    if (!props.match.params || !props.match.params.id) {
      throw new Error('props.match.params.id is required');
    }
    super(props);
    this.handleBack = routeHelper.updateURL.bind(routeHelper, '/admin/organizations');
    this.handleChange = (contentPath, value) => {
      props.organizationActions.change(props.organization.active.id, contentPath, value);
    };
    this.handleSave = this.handleSave.bind(this);
    this.validate = this.validate.bind(this);
  }
  componentDidMount() {
    const {
      canView,
      location,
      coatingScore,
      coatingScoreActions,
      match,
      organization,
      organizationActions
    } = this.props;
    routeHelper.handleViewRedirect(canView, location);
    if (!organization.active.isNew) {
      organizationActions.serverShow(match.params.id);
    }
    if (coatingScore.list && coatingScore.list.length === 0) {
      coatingScoreActions.serverIndex(coatingScore.indexQuery);
    }
  }
  componentDidUpdate() {
    const {
      coatingScore,
      organization: {
        active,
        loading
      },
      organizationActions: {
        setDefaultCoatingScoreDivisions
      },
      userID
    } = this.props;
    if (active && active.coatingScoreDivisions && active.coatingScoreDivisions.length === 0 && !loading && coatingScore.list && coatingScore.list.length > 0) {
      const createdDate = moment().utc().format('YYYY-MM-DD HH:mm:ss');
      const coatingScoreDivisionIDs = [];
      for (let i = 0; i < 8; i += 1) {
        coatingScoreDivisionIDs.push(uuidV4());
      }
      setDefaultCoatingScoreDivisions(active.id, userID, coatingScoreDivisionIDs, coatingScore.list, createdDate);
    }
  }
  componentWillUnmount() {
    const {
      organizationActions: {
        showCancel
      }
    } = this.props;
    showCancel();
  }
  handleSave() {
    const {
      organization,
      organizationActions
    } = this.props;
    const errors = this.validate();
    const {
      active
    } = organization;
    if (errors.length > 0) {
      organizationActions.errorMessage(errors);
    } else {
      organizationActions.serverSave(active);
    }
  }
  validate() {
    const {
      organization: {
        active: {
          coatingScoreDivisions,
          name
        }
      }
    } = this.props;
    const errors = [];
    if (!name) {
      errors.push('The organization name is required.');
    }
    let nullCoatingScores = [];
    nullCoatingScores = _.filter(coatingScoreDivisions, division => division.cost === null);
    if (nullCoatingScores.length > 0) {
      errors.push('All coating score divisions must be filled in.');
    }
    return errors;
  }
  render() {
    const {
      hasFacilityPermissions,
      hasGeneralPermissions,
      match,
      organization,
      userID
    } = this.props;
    let section = match.params.section || 'general';
    const {
      loading,
      pendingChanges,
      active: {
        name
      }
    } = organization;
    if (!hasGeneralPermissions) {
      // we don't want to show the default section.
      section = '';
    }
    const props = {
      organization: organization.active,
      hasFacilityPermissions,
      onChange: this.handleChange,
      userID
    };
    const forms = {
      '': /*#__PURE__*/React.createElement("div", null, "You do not have permissions to administer this information."),
      general: /*#__PURE__*/React.createElement(OrgGeneral, props),
      condCost: /*#__PURE__*/React.createElement(OrgConditionCosts, props)
    };
    const sectionRoutes = Object.keys(forms).map(formKey => path.join('/admin/organizations/', match.params.id, formKey));
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Prompt, {
      when: pendingChanges,
      message: location => routeHelper.transitionAsync(this, 'organization', location, sectionRoutes)
    }), /*#__PURE__*/React.createElement(OrgContainer, {
      section: section,
      id: match.params.id
    }, /*#__PURE__*/React.createElement(SectionPanel, {
      isPending: pendingChanges,
      isSaveDisabled: loading || !pendingChanges,
      onBack: this.handleBack,
      onSave: this.handleSave,
      name: name,
      showSave: true
    }, forms[section])));
  }
}
Organization.propTypes = {
  canView: PropTypes.bool.isRequired,
  location: PropTypes.shape({}).isRequired,
  coatingScore: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  coatingScoreActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  hasFacilityPermissions: PropTypes.bool.isRequired,
  hasGeneralPermissions: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      section: PropTypes.string
    }).isRequired
  }).isRequired,
  organization: PropTypes.shape({
    loading: PropTypes.bool,
    pendingChanges: PropTypes.bool,
    active: PropTypes.shape({
      coatingScoreDivisions: PropTypes.arrayOf(PropTypes.shape({})),
      id: PropTypes.string,
      isNew: PropTypes.bool,
      name: PropTypes.string
    }).isRequired
  }).isRequired,
  organizationActions: PropTypes.shape({
    change: PropTypes.func,
    errorMessage: PropTypes.func,
    setDefaultCoatingScoreDivisions: PropTypes.func,
    serverSave: PropTypes.func,
    serverShow: PropTypes.func,
    showCancel: PropTypes.func
  }).isRequired,
  userID: PropTypes.string.isRequired
};
export { Organization as TestOrganization };
export default entityComposition(Organization, ['organization', 'coatingScore'], {
  userID: state => state.login.user.user_id,
  hasFacilityPermissions: () => hasAdminSubSectionPermission('organizations_facility'),
  hasGeneralPermissions: () => hasAdminSubSectionPermission('organizations_general'),
  canView: state => viewPermissionSelector('organization')(state)
});